// extracted by mini-css-extract-plugin
export default {"navNameLength":"style_navNameLength__cyveW","navicon":"style_navicon__Ld5Kl"};